//#region DevExtreme Imports

import 'devextreme/ui/popup'
import 'devextreme/ui/select_box'
import 'devextreme/ui/toolbar'

//#endregion

import { USER_SESSION_SERVICE_NAME } from '../../../services/user-session'
import { TASK_SERVICE_NAME } from '../../../services/task'

import { TaskStatusChangeController } from "./tasks-status-change.controller"

export const COMPONENT_NAME: string = 'taskStatusChange'

//#region Asset Imports

import './tasks-status-change.scss'
import * as TEMPLATE from './tasks-status-change.tpl.html'

//#endregion

export class TaskStatusChangeComponent implements ng.IComponentOptions {

    controller = [
        USER_SESSION_SERVICE_NAME,
        TASK_SERVICE_NAME,
        TaskStatusChangeController
    ]

    bindings = {
        options: '<'
    } as { [index: string]: string }

    template = TEMPLATE
}
